(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     Styles
  ───────────────────────────────────────────── */
  var CSS = /* css */`
    /* Overlay */
    .nfs-overlay {
      position: fixed;
      inset: 0;
      z-index: 8000;
      pointer-events: none;
    }
    .nfs-overlay.nfs-open {
      pointer-events: auto;
    }

    /* Backdrop */
    .nfs-backdrop {
      position: absolute;
      inset: 0;
      background: transparent;
      transition: background 0.38s ease;
    }
    .nfs-open .nfs-backdrop {
      background: rgba(0, 0, 0, 0.42);
    }

    /* ── Panel ── */
    .nfs-panel {
      position: absolute;
      background: var(--color-background, #fff);
      display: flex;
      flex-direction: column;
      outline: none;
    }

    /* Mobile: bottom sheet */
    @media (max-width: 639px) {
      .nfs-panel {
        bottom: 0;
        left: 0;
        right: 0;
        max-height: 88vh;
        border-radius: 18px 18px 0 0;
        box-shadow: 0 -12px 48px rgba(0, 0, 0, 0.14);
        transform: translateY(102%);
        transition: transform 0.42s cubic-bezier(0.16, 1, 0.3, 1);
      }
      .nfs-open .nfs-panel {
        transform: translateY(0);
      }
    }

    /* Desktop: right-side drawer */
    @media (min-width: 640px) {
      .nfs-panel {
        top: 0;
        right: 0;
        bottom: 0;
        width: 420px;
        max-width: 100vw;
        box-shadow: -12px 0 48px rgba(0, 0, 0, 0.1);
        transform: translateX(100%);
        transition: transform 0.42s cubic-bezier(0.16, 1, 0.3, 1);
      }
      .nfs-open .nfs-panel {
        transform: translateX(0);
      }
    }

    /* Drag handle (mobile only) */
    .nfs-handle {
      width: 40px;
      height: 4px;
      border-radius: 99px;
      background: #e0e0e0;
      margin: 10px auto 0;
      flex-shrink: 0;
    }
    @media (min-width: 640px) {
      .nfs-handle { display: none; }
    }

    /* Header */
    .nfs-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1.1rem 1.35rem 1rem;
      border-bottom: 1px solid #f0f0f0;
      flex-shrink: 0;
    }
    .nfs-header__left {
      display: flex;
      align-items: baseline;
      gap: 0.45rem;
    }
    .nfs-header__title {
      font-family: var(--font-primary--family, inherit);
      font-size: 0.95rem;
      font-weight: 600;
      letter-spacing: 0.03em;
      text-transform: uppercase;
      color: var(--color-foreground, #111);
    }
    .nfs-header__count {
      font-size: 0.78rem;
      color: #aaa;
      font-weight: 400;
      letter-spacing: 0;
      text-transform: none;
    }
    .nfs-close {
      background: none;
      border: none;
      cursor: pointer;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      font-size: 1.05rem;
      transition: background 0.15s, color 0.15s;
      padding: 0;
      flex-shrink: 0;
    }
    .nfs-close:hover { background: #f3f3f3; color: #111; }
    .nfs-close svg { width: 16px; height: 16px; }

    /* Empty state */
    .nfs-empty {
      display: none;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.6rem;
      padding: 4rem 2rem 3rem;
      text-align: center;
      flex: 1;
    }
    .nfs-empty svg {
      width: 2.8rem;
      height: 2.8rem;
      stroke: #d8d8d8;
      margin-bottom: 0.5rem;
    }
    .nfs-empty__title {
      font-size: 0.92rem;
      font-weight: 600;
      color: #444;
      margin: 0;
    }
    .nfs-empty__sub {
      font-size: 0.8rem;
      color: #bbb;
      line-height: 1.55;
      max-width: 220px;
    }

    /* List */
    .nfs-list {
      flex: 1;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
    }

    /* Item */
    .nfs-item {
      display: flex;
      align-items: center;
      gap: 0.9rem;
      padding: 0.85rem 1.35rem;
      transition: background 0.12s;
      position: relative;
    }
    .nfs-item + .nfs-item {
      border-top: 1px solid #f5f5f5;
    }
    .nfs-item:hover { background: #fafafa; }

    /* Thumbnail */
    .nfs-item__img {
      flex-shrink: 0;
      width: 68px;
      height: 68px;
      border-radius: 6px;
      overflow: hidden;
      background: #f2f2f2;
      display: block;
      text-decoration: none;
    }
    .nfs-item__img img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.28s ease;
    }
    .nfs-item:hover .nfs-item__img img { transform: scale(1.07); }

    /* Info */
    .nfs-item__info {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }
    .nfs-item__name {
      font-size: 0.87rem;
      font-weight: 500;
      color: var(--color-foreground, #111);
      text-decoration: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.3;
      transition: opacity 0.12s;
    }
    .nfs-item__name:hover { opacity: 0.65; }
    .nfs-item__price {
      font-size: 0.83rem;
      color: #888;
    }
    .nfs-item__shop {
      display: inline-block;
      margin-top: 0.3rem;
      font-size: 0.78rem;
      font-weight: 600;
      color: var(--color-foreground, #111);
      text-decoration: underline;
      text-underline-offset: 2px;
      letter-spacing: 0.02em;
      transition: opacity 0.12s;
    }
    .nfs-item__shop:hover { opacity: 0.55; }

    /* Remove */
    .nfs-item__remove {
      flex-shrink: 0;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0.35rem;
      color: #bbb;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: color 0.15s, background 0.15s;
      line-height: 1;
    }
    .nfs-item__remove svg { width: 14px; height: 14px; }
    .nfs-item__remove:hover {
      color: #555;
      background: #f0f0f0;
    }

    /* Footer */
    .nfs-footer {
      flex-shrink: 0;
      padding: 0.9rem 1.35rem calc(0.9rem + env(safe-area-inset-bottom, 0px));
      border-top: 1px solid #f0f0f0;
      display: flex;
      gap: 0.6rem;
    }
    .nfs-btn {
      flex: 1;
      display: block;
      text-align: center;
      padding: 0.82rem 1rem;
      font-size: 0.82rem;
      font-weight: 600;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      border-radius: 3px;
      border: 1.5px solid var(--color-foreground, #111);
      cursor: pointer;
      text-decoration: none;
      transition: background 0.15s, color 0.15s;
      line-height: 1;
    }
    .nfs-btn--outline {
      background: transparent;
      color: var(--color-foreground, #111);
    }
    .nfs-btn--outline:hover {
      background: var(--color-foreground, #111);
      color: var(--color-background, #fff);
    }
    .nfs-btn--fill {
      background: var(--color-foreground, #111);
      color: var(--color-background, #fff);
      border-color: var(--color-foreground, #111);
    }
    .nfs-btn--fill:hover { background: #333; border-color: #333; }
    .nfs-btn--fill:disabled {
      opacity: 0.45;
      cursor: default;
    }

    /* Adding to cart animation */
    @keyframes nfs-pulse {
      0%, 100% { opacity: 1; }
      50%       { opacity: 0.55; }
    }
    .nfs-btn--loading { animation: nfs-pulse 0.9s ease infinite; }

    body:has(.nfs-overlay.nfs-open) #shopify-chat { display: none !important; }
  `;

  /* ─────────────────────────────────────────────
     Build DOM
  ───────────────────────────────────────────── */
  function buildSheet() {
    var el = document.createElement('div');
    el.className = 'nfs-overlay';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Saved Rugs');
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="nfs-backdrop"></div>' +
      '<div class="nfs-panel" tabindex="-1">' +
        '<div class="nfs-handle"></div>' +
        '<div class="nfs-header">' +
          '<div class="nfs-header__left">' +
            '<span class="nfs-header__title">Saved Rugs</span>' +
            '<span class="nfs-header__count" id="nfs-count"></span>' +
          '</div>' +
          '<button class="nfs-close" aria-label="Close">' +
            '<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="2" y1="2" x2="16" y2="16"/><line x1="16" y1="2" x2="2" y2="16"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="nfs-empty" id="nfs-empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true">' +
            '<path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>' +
          '</svg>' +
          '<p class="nfs-empty__title">Nothing saved yet</p>' +
          '<span class="nfs-empty__sub">Tap the heart on any rug to save it here.</span>' +
        '</div>' +
        '<div class="nfs-list" id="nfs-list"></div>' +
        '<div class="nfs-footer" id="nfs-footer" style="display:none;">' +
          '<a href="/collections/all" class="nfs-btn nfs-btn--outline">Browse all</a>' +
          '<button class="nfs-btn nfs-btn--fill" id="nfs-atc-all">Add all to cart</button>' +
        '</div>' +
      '</div>';

    return el;
  }

  /* ─────────────────────────────────────────────
     Add all to cart — fetches each product's
     first available variant then POSTs to cart
  ───────────────────────────────────────────── */
  function addAllToCart(items, btn) {
    if (!items.length) return;
    btn.disabled = true;
    btn.classList.add('nfs-btn--loading');
    var original = btn.textContent;
    btn.textContent = 'Adding…';

    var fetches = items.map(function (p) {
      // Fetch product JSON to get the first available variant id
      return fetch(p.url + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var variant = (data.variants || []).find(function (v) { return v.available; });
          return variant ? variant.id : null;
        })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (variantIds) {
      var items = variantIds
        .filter(Boolean)
        .map(function (id) { return { id: id, quantity: 1 }; });

      if (!items.length) {
        reset('Nothing available');
        return Promise.reject('handled');
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (d) { if (!r.ok) throw d; return d; });
      });
    }).then(function () {
      if (window.clarity) { window.clarity('event', 'AddToCart'); }
      btn.classList.remove('nfs-btn--loading');
      btn.textContent = 'Added!';
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = original;
        // Refresh cart count if possible
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }, 1800);
    }).catch(function (err) {
      if (err !== 'handled') reset('Try again');
    });

    function reset(msg) {
      btn.classList.remove('nfs-btn--loading');
      btn.disabled = false;
      btn.textContent = msg;
      setTimeout(function () { btn.textContent = original; }, 2000);
    }
  }

  /* ─────────────────────────────────────────────
     Init
  ───────────────────────────────────────────── */
  function init() {
    var fav = window.NileFavourites;
    if (!fav) return;

    // Inject CSS
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    // Build and mount sheet
    var overlay = buildSheet();
    document.body.appendChild(overlay);

    var panel     = overlay.querySelector('.nfs-panel');
    var backdrop  = overlay.querySelector('.nfs-backdrop');
    var closeBtn  = overlay.querySelector('.nfs-close');
    var listEl    = overlay.querySelector('#nfs-list');
    var emptyEl   = overlay.querySelector('#nfs-empty');
    var footerEl  = overlay.querySelector('#nfs-footer');
    var countEl   = overlay.querySelector('#nfs-count');
    var atcAllBtn = overlay.querySelector('#nfs-atc-all');

    /* -- Open / Close -- */
    function open() {
      render();
      overlay.classList.add('nfs-open');
      overlay.setAttribute('aria-hidden', 'false');
      if (favBtn) favBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { panel.focus(); }, 50);
    }

    function close() {
      overlay.classList.remove('nfs-open');
      overlay.setAttribute('aria-hidden', 'true');
      if (favBtn) favBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (favBtn) favBtn.focus();
    }

    backdrop.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('nfs-open')) close();
    });

    /* -- Wire header button -- */
    var favBtn = document.getElementById('fav-btn');
    if (favBtn) {
      favBtn.addEventListener('click', function (e) {
        e.preventDefault();
        overlay.classList.contains('nfs-open') ? close() : open();
      });
    }

    /* -- Add all to cart -- */
    if (atcAllBtn) {
      atcAllBtn.addEventListener('click', function () {
        addAllToCart(fav.getAll(), atcAllBtn);
      });
    }

    /* -- Re-render when fav list changes -- */
    document.addEventListener('nile:fav-changed', render);

    /* -- Render list -- */
    function render() {
      var items = fav.getAll();
      var count = items.length;

      // Update badge
      countEl.textContent = count > 0 ? '(' + count + ')' : '';

      if (count === 0) {
        emptyEl.style.display  = 'flex';
        listEl.style.display   = 'none';
        footerEl.style.display = 'none';
        return;
      }

      emptyEl.style.display  = 'none';
      listEl.style.display   = 'block';
      footerEl.style.display = 'flex';

      listEl.innerHTML = items.map(function (p) {
        var img = p.image
          ? '<img src="' + p.image + '" alt="' + escHtml(p.title) + '" loading="lazy">'
          : '';
        return (
          '<div class="nfs-item">' +
            '<a href="' + p.url + '" class="nfs-item__img">' + img + '</a>' +
            '<div class="nfs-item__info">' +
              '<a href="' + p.url + '" class="nfs-item__name">' + escHtml(p.title) + '</a>' +
              '<span class="nfs-item__price">' + escHtml(p.price) + '</span>' +
              '<a href="' + p.url + '" class="nfs-item__shop">View rug &rarr;</a>' +
            '</div>' +
            '<button class="nfs-item__remove" data-id="' + p.id + '" aria-label="Remove ' + escHtml(p.title) + ' from saved">' +
              '<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="2" y1="2" x2="16" y2="16"/><line x1="16" y1="2" x2="2" y2="16"/></svg>' +
            '</button>' +
          '</div>'
        );
      }).join('');

      // Wire remove buttons
      listEl.querySelectorAll('.nfs-item__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          fav.remove(btn.dataset.id);
          // Update product page heart if visible
          syncProductPageHeart(btn.dataset.id, false);
        });
      });
    }
  }

  /* Sync the product page wishlist button state without a full page reload */
  function syncProductPageHeart(id, active) {
    var btn = document.getElementById('prd-btn-wishlist');
    if (!btn || String(btn.dataset.favId) !== String(id)) return;
    var icon = btn.querySelector('i');
    if (active) {
      btn.classList.add('prd-btn-wishlist--active');
      btn.setAttribute('aria-label', 'Remove from favourites');
    } else {
      btn.classList.remove('prd-btn-wishlist--active');
      btn.setAttribute('aria-label', 'Add to favourites');
    }
    if (icon) icon.className = 'fa-regular fa-heart';
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
